import React, { Component } from "react"

/* Modal */
import Modal from 'react-modal'

/* Helpers */
import { utils } from "../helpers"

/* Moment */
import moment from 'moment'
import 'moment/locale/ru'

/* DatePicker */
import DatePicker, { registerLocale } from 'react-datepicker'
import ru from "date-fns/locale/ru"

/* DatePicker Settings */
registerLocale("ru", ru)

/* Moment Settings */
moment.locale("ru")

/* Fields */
const DATES = [
    { key: "all", text: "За все время" },
    { key: "today", text: "За сегодня" },
    { key: "week", text: "За неделю" },
    { key: "month", text: "За месяц" },
    { key: "year", text: "За год" },
    { key: "period", text: "Период" },
]

class DateFilter extends Component {

    /* Set a period value */
    setDate = (data, key) => {
        const { setVariables } = this.props
        if (key === "start") {
            setVariables({ start: data })
        } else {
            setVariables({ end: data })
        }
    }

    apply = () => {

        const { selected, setVariables } = this.props

        if (selected === "all" || selected === "period") {
            setVariables({ active: selected, filter: false, load: true })
        }
        else {
            const { start, end } = utils.getFilterDates(selected)
            setVariables({ active: selected, start, end, filter: false, load: true })
        }


    }

    /* Get Filter Date */
    getFilterDate = () => {

        const { active, start, end } = this.props

        const index = DATES.findIndex(e => e.key === active)

        if (index > -1) {

            let text = `${moment(start).format("DD MMM 'YY")} - ${moment(end).format("DD MMM 'YY")}`

            if (active === "all") {
                text = ""
            }

            return { filter: DATES[index].text, text }
        }

        return { filter: DATES[0].text, text: "" }
    }


    /* Draw Filter Modal */
    _filter = () => {

        /* Fields */
        const { filter, start, end, selected, active, setVariables } = this.props

        return (
            <Modal
                isOpen={filter}
                onRequestClose={() => setVariables({ filter: false, selected: active })}
                className={`header-date-filter-modal ${selected === "period" ? "period" : ""}`}
                overlayClassName="header-date-filter-overlay"
                closeTimeoutMS={200}
            >

                <div className="header-date-filter-header">
                    <h2>Выберите дату</h2>
                    <div onClick={() => setVariables({ filter: false, selected: active })} className="header-date-filter-close">
                        <img src="/images/close.png" alt="Close" />
                    </div>
                </div>

                <div className="header-date-filter-container">

                    <div className="header-date-filter-container-inner">

                        {/* Dates */}
                        <div className="header-date-filter-dates">
                            {DATES.map((item, index) =>
                                <div onClick={() => setVariables({ selected: item.key })} className={`header-date-filter-date ${item.key === selected ? 'active' : 'default'}`} key={`${index}`}>{item.text}</div>
                            )}
                        </div>

                        {/* Period */}
                        {selected === "period" &&
                            <div className="header-date-filter-period-container">

                                <div className="header-date-filter-period-title">Выберите даты</div>

                                <div className="header-date-filter-period">

                                    <DatePicker
                                        ref={ref => this._start = ref}
                                        selected={start}
                                        onChange={date => this.setDate(date, "start")}
                                        selectsStart
                                        startDate={start}
                                        endDate={end}
                                        dateFormat="dd-MM-yyyy"
                                        locale="ru"
                                    />

                                    <span>-</span>

                                    <DatePicker
                                        selected={end}
                                        onChange={date => this.setDate(date, "end")}
                                        selectsEnd
                                        startDate={start}
                                        endDate={end}
                                        minDate={start}
                                        dateFormat="dd-MM-yyyy"
                                        locale="ru"
                                    />
                                </div>
                            </div>
                        }

                    </div>

                    {/* Bottom */}
                    <div className="header-date-filter-bottom">
                        <div onClick={() => setVariables({ filter: false, selected: active })} className="header-date-filter-button cancel">Отменить</div>
                        <div onClick={() => this.apply()} className="header-date-filter-button">Применить</div>
                    </div>

                </div>

            </Modal>
        )
    }

    render = () => {

        const { setVariables } = this.props

        const date = this.getFilterDate()

        return (
            <>
                <div onClick={() => setVariables({ filter: true })} className="header-date-filter">
                    <img src="/images/calendar.png" alt="Calendar" />
                    <div className="header-date-filter-text">
                        <div className="header-date-filter-text-type">{date.filter}</div>
                        <div className="header-date-filter-text-value">{date.text}</div>
                    </div>
                </div>
                {this._filter()}
            </>
        )

    }

}

export default DateFilter